import { isNumber } from '$common/utils/validate'
import { goPage } from '$common/utils/url'
window.isDev = process.env.NODE_ENV === 'development';
export default {
  data() {
    const currentKeyCodeEnum = {
      8: 'del',
      13: 'enter'
    };
    for (let i = 0; i <= 9; i++) {
      currentKeyCodeEnum[i + 48] = `${i}`;
      currentKeyCodeEnum[i + 96] = `${i}`;
    }
    return {
      isDev: window.isDev,
      currentKeyCode: undefined,
      currentKeyCodeEnum,
      currentKeyCodeMiddleWare: {}
    };
  },
  mounted() {
    this.$nextTick(() => {
      document.onkeydown = event => {
        if (typeof this.currentKeyCodeMiddleWare === 'object') {
          Object.keys(this.currentKeyCodeMiddleWare).forEach(eKey => {
            if (typeof this.currentKeyCodeMiddleWare[eKey] === 'function') {
              this.currentKeyCodeMiddleWare[eKey](event);
            }
          });
        }
        if (this.currentKeyCodeEnum[event.keyCode]) {
          this.currentKeyCode = this.currentKeyCodeEnum[event.keyCode];
          this.timeout(() => {
            this.currentKeyCode = undefined;
          }, 50);
        }
      }
    });
  },
  methods: {
    //  是否是数字
    isNumber,
    //  异步定时器
    timeout(callback, timestamp = 0) {
      const timeout = setTimeout(() => {
        clearTimeout(timeout);
        callback();
      }, timestamp);
      return timeout;
    },
    //  去除所有空格
    trim: data => String(data).replace(/\s/g, ''),
    //  转换成数字
    toNumber: num => num - 0 || 0,
    //  四舍五入转换数字
    toFixed(num) {
      return this.toNumber(this.toNumber(num).toFixed(2));
    },
    //  生成约定长度的随机数
    getMathRandom(randomLength = 4) {
      let maxLengthNum = '1';
      const __langth = (randomLength - 0) || 1;
      for (let i = 0; i < __langth; i++) {
        maxLengthNum += '0';
      }
      const str = parseInt(Math.random() * ((maxLengthNum - 0) || 1), 10).toString();
      return str.length === __langth && str || this.getMathRandom();
    },
    //  清空对象
    clearObject(data, key, father) {
      if (data) {
        try {
          const dataType = typeof data;
          if (dataType === 'object') {
            if (Array.isArray(data)) {
              for (let i = 0, len = data.length; i < len; i++) {
                if (data[i]) {
                  data[i] = this.clearObject(data[i], i, data);
                }
              }
              data.length = 0;
              father[key] = [];
            } else {
              for (const __key of Object.keys(data)) {
                if (data[__key]) {
                  data[__key] = this.clearObject(data[__key], __key, data);
                }
                delete data[__key];
              }
              delete father[key];
            }
          }
        } catch (error) {
          console.log('error: ', error)
        }
      }
    },
    //  设置返回按钮事件
    setBackPopstate(callback, isClear = true) {
      const popstateEvent = (e) => {
        if (isClear) {
          window.removeEventListener('popstate', popstateEvent);
        }
        typeof callback === 'function' && callback(e);
      };
      window.addEventListener('popstate', popstateEvent, false);
      window.history.pushState({
        title: document.title,
        url: window.location.href
      }, document.title, window.location.href);
      return popstateEvent;
    },
    goPage: goPage
  }
}
